// import React from 'react';
// import styled from 'styled-components';

// const FooterContainer = styled.footer`
//     background-color: #282c34;
//     color: white;
//     text-align: center;
//     padding: 20px;
//     position: relative;
//     bottom: 0;
//     width: 100%;
// `;

// const Footer = () => {
//     return (
//         <FooterContainer>
//             <p>&copy; {new Date().getFullYear()} My Software Development Company. All rights reserved.</p>
//         </FooterContainer>
//     );
// };

// export default Footer;



import React from 'react';
import styled from 'styled-components';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';

const FooterContainer = styled.footer`
    background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 100%);
    color: white;
    padding: 4rem 2rem 2rem;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    }
`;

const FooterContent = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 3rem;
    margin-bottom: 3rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 2rem;
    }
`;

const FooterSection = styled.div`
    h3 {
        color: #FFC857;
        margin-bottom: 1.5rem;
        font-size: 1.3rem;
        font-weight: 700;
    }

    p {
        line-height: 1.7;
        color: rgba(255, 255, 255, 0.9);
        margin-bottom: 1rem;
    }
`;

const ContactInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const ContactItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    color: rgba(255, 255, 255, 0.9);

    svg {
        color: #FFC857;
        margin-top: 0.2rem;
        flex-shrink: 0;
    }

    a {
        color: rgba(255, 255, 255, 0.9);
        text-decoration: none;
        transition: color 0.3s ease;

        &:hover {
            color: #FFC857;
        }
    }
`;

const SocialLinks = styled.div`
    display: flex;
    gap: 1rem;
    margin-top: 1rem;

    a {
        color: white;
        background: rgba(255, 255, 255, 0.1);
        padding: 0.8rem;
        border-radius: 50%;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            background: #FFC857;
            color: var(--theme-primary);
            transform: translateY(-2px);
        }
    }
`;

const FooterBottom = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 2rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.9rem;
`;

const Footer = () => {
    return (
        <FooterContainer>
            <FooterContent>
                <FooterSection>
                    <h3>VVV IT Solutions</h3>
                    <p>
                        Transforming businesses through cutting-edge technology solutions 
                        and expert software development services. Your partner in digital 
                        innovation and excellence.
                    </p>
                    <SocialLinks>
                        <a href="#" aria-label="Facebook"><FaFacebook /></a>
                        <a href="#" aria-label="Twitter"><FaTwitter /></a>
                        <a href="#" aria-label="LinkedIn"><FaLinkedin /></a>
                        <a href="#" aria-label="Instagram"><FaInstagram /></a>
                    </SocialLinks>
                </FooterSection>
                
                <FooterSection>
                    <h3>Contact Info</h3>
                    <ContactInfo>
                        <ContactItem>
                            <FaMapMarkerAlt />
                            <span>109/421, 80 feet road, Kanpur(U.P), India</span>
                        </ContactItem>
                        <ContactItem>
                            <FaPhone />
                            <div>
                                <a href="tel:+919336652601">+91-9336652601</a><br />
                                <a href="tel:+919519510543">+91-9519510543</a>
                            </div>
                        </ContactItem>
                        <ContactItem>
                            <FaEnvelope />
                            <a href="mailto:shivnaresh@gmail.com">shivnaresh@gmail.com</a>
                        </ContactItem>
                    </ContactInfo>
                </FooterSection>
                
                <FooterSection>
                    <h3>Quick Links</h3>
                    <ContactInfo>
                        <ContactItem>
                            <a href="/about">About Us</a>
                        </ContactItem>
                        <ContactItem>
                            <a href="/services">Our Services</a>
                        </ContactItem>
                        <ContactItem>
                            <a href="/career">Career</a>
                        </ContactItem>
                        <ContactItem>
                            <a href="/contact">Contact</a>
                        </ContactItem>
                    </ContactInfo>
                </FooterSection>
            </FooterContent>
            
            <FooterBottom>
                <p>&copy; {new Date().getFullYear()} VVV IT Solutions Pvt. Ltd. All rights reserved.</p>
            </FooterBottom>
        </FooterContainer>
    );
};

export default Footer;
